var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.35449 7.43266C2.35449 4.31968 4.88708 1.78711 8 1.78711C11.1129 1.78711 13.6455 4.31968 13.6455 7.43266H2.35449Z",
    fill: "#E7886E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6788 9.02901C13.4085 9.02901 14 8.43755 14 7.70788C14 6.97822 13.4085 6.38672 12.6788 6.38672C11.9491 6.38672 11.3577 6.97822 11.3577 7.70788C11.3577 8.43755 11.9491 9.02901 12.6788 9.02901Z",
    fill: "#FED2A4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.98096 15.2122C4.35798 15.2122 3.92269 14.5589 4.14233 13.9434C4.68944 12.4023 6.21094 11.2969 8.00002 11.2969C9.78909 11.2969 11.3106 12.4023 11.8577 13.9434C12.0774 14.5589 11.642 15.2122 11.0191 15.2122H4.98096Z",
    fill: "#5C586F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.17285 7.25319C4.17285 4.59348 5.91563 2.36659 8.25322 1.79308C8.16929 1.78936 8.08489 1.78711 8.00002 1.78711C4.88711 1.78711 2.35455 4.31968 2.35455 7.43266H4.17583C4.17404 7.37299 4.17285 7.31326 4.17285 7.25319Z",
    fill: "#E7886E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3888 4.97063C10.966 5.19973 10.4561 5.19973 10.0333 4.97063C9.61047 4.74156 9.10053 4.74156 8.67773 4.97063C8.25493 5.19971 7.745 5.19971 7.3222 4.97063C6.8994 4.74156 6.38947 4.74156 5.96666 4.97063C5.54384 5.19971 5.03394 5.19971 4.61112 4.97063C4.45722 4.88725 4.29173 4.83461 4.12313 4.81192C3.6169 5.55948 3.32117 6.46122 3.32117 7.432C3.32117 10.0161 5.41592 12.1108 7.99993 12.1108C10.584 12.1108 12.6787 10.0161 12.6787 7.432C12.6787 6.46119 12.383 5.55948 11.8768 4.81192C11.7082 4.83461 11.5427 4.88725 11.3888 4.97063Z",
    fill: "#FED2A4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.40497 11.8323C5.05465 10.8177 4.17282 9.14499 4.17282 7.25312C4.17282 6.44321 4.3347 5.67359 4.62551 4.9784C4.62078 4.97589 4.6159 4.97375 4.6112 4.97121C4.45729 4.88783 4.2918 4.83519 4.1232 4.8125C3.80321 5.28505 3.5675 5.8192 3.43722 6.39343C3.40052 6.38981 3.36211 6.38768 3.32124 6.38768C2.59159 6.38768 2.00009 6.97918 2.00009 7.70885C2.00009 8.43852 2.59159 9.02999 3.32124 9.02999C3.42337 9.02999 3.5118 9.01799 3.58908 8.99612C4.05544 10.3117 5.09363 11.3568 6.40497 11.8323Z",
    fill: "#FED2A4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.e97ccca344be6a10e8f39f91329444cc.svg";
export { ForwardRef as ReactComponent };